import type { FaireProductEntity } from "../../entity_types/product";

export const p_bd8s9ykvwq: FaireProductEntity = {
  token: "p_bd8s9ykvwq",
  type: "product",
  name: "French Terry Core Sweatshirt (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/465b4fb4086cf1851c59d5c8035a148e8a832d20ea8088faa797df63d3dcdf3f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d57c4a22f48c8727189e9d3639a85a1ca5e520be14ef102dab1c8f0cca005267.jpeg",
    "https://cdn.faire.com/fastly/7e64df6244f1ea8eab5b2cdc90e962139367c247e3cc6d5f44619a77d4aa86f0.jpeg",
    "https://cdn.faire.com/fastly/8904b4ad9f02af0d46a45c0c8d77d0823febe1613ab14c1f555ac39f45df3e83.jpeg",
    "https://cdn.faire.com/fastly/c53da7990e48ed28876b125a551812b121e644c6ce51df9c543b7f5f9335b34e.jpeg",
    "https://cdn.faire.com/fastly/0b8dc2563eb0ccb23b168f24897b8ef3962411930f86e177e2beb80b78d54a28.jpeg",
    "https://cdn.faire.com/fastly/0a09ebc1cd47cffa8f790edf1a13dd9926a28a5c1208ed242598f088d48f0c83.jpeg",
    "https://cdn.faire.com/fastly/559651db3b8e3e5c951f4571469978cb44b7cc33a3b2bf7489f37de3530d26fb.jpeg",
    "https://cdn.faire.com/fastly/499be3a32b54ee58cc055c1947e69e790c73136b2bcd4bc15e79bcf61a469206.jpeg",
    "https://cdn.faire.com/fastly/c5874d94f68839f97a7cc4bc10672ba72d2654ab3ea9dd0fa80fe4b7612e50a1.jpeg",
    "https://cdn.faire.com/fastly/2b4f2098425f28761e8184788d6d2fe9d9ac8bcbcd3014e7a37524a9cd1c9060.jpeg",
    "https://cdn.faire.com/fastly/c986793efeea2435a3d93eb1d3f5702c35e5e8d2cda80ca004bace4cbdd063ec.jpeg",
    "https://cdn.faire.com/fastly/f0c150de006b08c322a570f4382b8f2ae173310252ef76875af41f1efe9d6126.jpeg",
    "https://cdn.faire.com/fastly/7c41b36129d655af8e32deabbcfcd52ffe02d1763b60822f3d2fac6f76f9dc7b.jpeg",
    "https://cdn.faire.com/fastly/f050765a2bf88b332bafb1e7bf224ead5c20a8a718d38f34dad31cf0bb5bf78a.jpeg",
    "https://cdn.faire.com/fastly/aa5b7d1c135007d2800adbd7bff44940b054677463f988002ff9c5068d7d35c4.jpeg",
    "https://cdn.faire.com/fastly/37b62ce85144cae60c216f034728d1d416aba7e62c0a9ebfc8f90446421d54dd.jpeg",
    "https://cdn.faire.com/fastly/85bb705d9b66539c920a990febca278a1827c4f86ace0a87eb67928a2f14966b.jpeg",
  ],
  priceDollars: 176,
  description:
    '𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nThe sweatshirt you’ll reach for again and again. With a smooth outer finish and soft French terry interior, it feels like your favorite vintage crew—easy, cozy, and perfectly broken in. Its relaxed, boxy fit makes layering effortless no matter how you style it.\n\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n100% Cotton French Terry\n\n\nMade in South Korea\n\n\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Washing these garments only with like colors and in cold water\n• Recommend to Hang Dry for the best result\n\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\nXS/S: Length 23", Chest 23"\n\nM/L: Length 23 1/2", Chest 24"\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS\n\n\n𝐌𝐒𝐑𝐏:\n\n$110 USD',
  tags: [],
  msrpDollars: 352,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:08.323Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
